import { SvgIcon } from '../../../../components/Icon';
import { ExpandCollapseButtonDiv } from './SchemaEntityRelationsUI';

interface IProps {
  expanded: boolean;
  onClick: () => void;
}

const ExpandCollapseButton = ({ expanded, onClick }: IProps) => {
  return (
    <ExpandCollapseButtonDiv type="button" isOutlined={true} onClick={onClick}>
      <SvgIcon
        width={12}
        height={12}
        name={expanded ? 'caret-up' : 'caret-down'}
        customFill="currentColor"
      />
      {expanded ? 'Collapse details' : 'Expand details'}
    </ExpandCollapseButtonDiv>
  );
};

export default ExpandCollapseButton;
